import React, { useState, useEffect } from 'react';
import './List-Component-Preview.scss';
import { useSelector } from 'react-redux';
import {
  allAmenitiesSelector,
  allRestaurantSelector,
  allRoomTypesSelector,
  allSpaInfoSelector,
} from '../../../../layouts/property/propertySlice';
import { ASSET_URL } from '../../../../env/Configurations';
import { offerSelector } from '../../../../layouts/cms/cmsSlice';

const ListComponentPreview = (props) => {
  const { config } = props;
  const originalRestaurant = useSelector(allRestaurantSelector);
  const originalSpa = useSelector(allSpaInfoSelector);
  const originalAmenities = useSelector(allAmenitiesSelector);
  const originalRooms = useSelector(allRoomTypesSelector);
  const originalOffers = useSelector(offerSelector);

  const [modulesList, setModulesList] = useState([]);

  useEffect(() => {
    const tempList = config?.listItems?.map((itemList) => {
      switch (config.hotelModule) {
        case 'AMENITY':
          return originalAmenities.find((item) => item.id === itemList.hotelModuleId);
        case 'RESTAURANT':
          return originalRestaurant.find((item) => item.id === itemList.hotelModuleId);
        case 'ROOMS':
          return originalRooms.find((item) => item.id === itemList.hotelModuleId);
        case 'WELLNESS':
          return originalSpa.find((item) => item.id === itemList.hotelModuleId);
        case 'OFFERS':
          return originalOffers.find((item) => item.id === itemList.hotelModuleId);
        default:
          return null;
      }
    });
    setModulesList(tempList);
  }, [config]);

  return (
    <div className='ui-list-component'>
      <div className='mx-2 mt-2 mb-3'>
        {modulesList?.map((listItem, index) => (
          <div key={index} className='mb-4'>
            <div
              className='ui-list-component-image-container'
              style={
                listItem && listItem?.images?.length
                  ? {
                      backgroundImage: 'url(' + ASSET_URL + listItem?.images[0]?.master + ')',
                      backgroundSize: 'cover',
                    }
                  : {}
              }
            >
              {!listItem && <span>Image</span>}
            </div>
            <div className='my-2'>{listItem?.name || 'Sub Module Title'}</div>
            {config.listItems[index]?.linkId && (
              <div className='my-2 ui-list-component-buttons'>
                <div className='py-2 ui-list-component-buttons-container'>SEE MORE DETAILS</div>
                <div className='py-2 ui-list-component-buttons-container'>BOOK</div>
              </div>
            )}
            {!config.listItems[index]?.linkId && (
              <div className='my-2 ui-list-component-buttons'>
                <div className='py-2 ui-list-component-book-button'>BOOK</div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListComponentPreview;
